

const PaymentButton = ({ path, name, onClick }) => {
  return (
    <div
      color="white"
      className="d-flex align-items-center justify-content-center border rounded p-3 border-[#ADACAC] "
      style={{
        height: "65px",
        width: "125px",
      }}
    >
      <img
        src={path}
        alt={name}
        style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "cover" }}
      />
    </div>
  );
};

export default PaymentButton;
